module.exports = __webpack_public_path__ + "static/media/expand.0be7ad34.svg";